import React, { useEffect, useMemo, useState } from "react";
import { Col, Form, Row, Select } from "antd";
import type { SelectValue } from "antd/lib/select";
import { useAppSelector } from "../../..";
import type { Agreement } from "../../../lib/types";
import { getSelectOptions } from "../../../lib/utils";
import MultipleSelect from "../../common/MultipleSelect";
import type { DictionaryDto } from "../../../lib/interfaces";
import "./ProductSelectAgreement.less";

interface ComponentProps {
  onChangeAgreement: (agreement: Agreement | undefined) => void;
  selectedAgreement?: Agreement;
}

export const ProductSelectAgreement = (props: ComponentProps) => {
  const { onChangeAgreement, selectedAgreement } = props;
  const agrStatus = useAppSelector((state) => state.rtkDictionaries.agrStatus);
  const agreements = useAppSelector((state) => state.agreements.agreements) as Agreement[];

  const [form] = Form.useForm();

  const handleChangeAgreement = (agreementId: SelectValue | undefined) => {
    form.setFieldsValue({ agreementId });
    if (agreementId) {
      const agreement: Agreement = agreements.find(({ id }) => id === agreementId)!;
      onChangeAgreement(agreement);
    } else {
      onChangeAgreement(undefined);
    }
  };

  const defaultSelectedStatuses = [1, 2, 3, 4, 5];
  const [selectedStatuses, setSelectedStatuses] = useState<number[]>(defaultSelectedStatuses);

  const filteredAgreements = useMemo(
    () =>
      agreements.filter(({ agreementStatusId }) => {
        if (selectedStatuses.length === 0) return true;
        return selectedStatuses.includes(agreementStatusId);
      }),
    [agreements, selectedStatuses]
  );

  const onChangeSelectedStatus = (values: (number | string)[]) => {
    const updatedStatuses = values.map(Number).filter(Boolean);
    setSelectedStatuses(updatedStatuses);
    handleChangeAgreement(undefined);
    // setFieldsValue({ agreementId: undefined });
  };

  // Установка договора по дефолту, в случае если он единственный
  useEffect(() => {
    if (filteredAgreements.length === 1) {
      handleChangeAgreement(filteredAgreements[0].id);
    }
  }, [filteredAgreements]);

  return (
    <Form form={form}>
      <Row>
        <Col span={8}>
          <Form.Item
            label="Номер договора"
            name="agreementId"
            rules={[
              {
                required: true,
                message: "",
              },
            ]}
            labelCol={{ span: 9 }}
            wrapperCol={{ offset: 1 }}
            initialValue={selectedAgreement?.id}
          >
            <Select
              options={getSelectOptions({
                list: filteredAgreements,
                labelName: "agreementNumber",
              })}
              allowClear
              onChange={handleChangeAgreement}
            />
          </Form.Item>
          <Form.Item
            label="Статус договора"
            labelCol={{ span: 9 }}
            wrapperCol={{ offset: 1, span: 14 }}
          >
            <MultipleSelect
              onChange={onChangeSelectedStatus}
              value={selectedStatuses}
              allValues={agrStatus?.map(({ id }) => id) || []}
              placeholder="Статус"
              allowClear
              maxTagCount={1}
              showSearch
              filterOption={(value, { children }) =>
                children.toLowerCase().includes(value.toLowerCase())
              }
            >
              {agrStatus.map(({ name, id }) => (
                <Select.Option key={id} value={id}>
                  {name}
                </Select.Option>
              ))}
            </MultipleSelect>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
